



































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import revisionAccessModule from "@/store/modules/RevisionAccessStore";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import type { RevisionAccessRequest } from "@/services/RevisionAccessService";

@Component
export default class PengajuanAksesRevisiPage extends Vue {
  tab = 0;
  historyStatus = "approved";

  approveDialog = false;
  rejectDialog = false;
  selected: RevisionAccessRequest | null = null;

  grantedMinutes = 1440;
  approveNote = "";
  rejectionReason = "";

  processing = false;

  pendingHeaders = [
    { text: "Tanggal Ajuan", value: "created_at", width: 150 },
    { text: "Pemohon", value: "requester" },
    { text: "Pasien", value: "pasien_nama" },
    { text: "Dokumen", value: "document_label", width: 170 },
    { text: "Tgl Keluar", value: "discharge_at", width: 150 },
    { text: "Alasan", value: "reason" },
    { text: "Aksi", value: "actions", sortable: false, width: 180 }
  ];

  historyHeaders = [
    { text: "Tanggal Ajuan", value: "created_at", width: 150 },
    { text: "Status", value: "status", width: 110 },
    { text: "Pemohon", value: "requester_nama" },
    { text: "Pasien", value: "pasien_nama" },
    { text: "Dokumen", value: "document_label", width: 170 },
    { text: "Approver", value: "approver_nama" },
    { text: "Akses sampai", value: "expires_at", width: 150 },
    { text: "Catatan", value: "note" }
  ];

  historyStatusOptions = [
    { text: "Disetujui", value: "approved" },
    { text: "Ditolak", value: "rejected" },
    { text: "Kedaluwarsa", value: "expired" },
    { text: "Semua", value: "all" }
  ];

  grantedMinutesRules = [
    (v: number) => (v && v >= 60) || "Minimal 60 menit",
    (v: number) => (v && v <= 10080) || "Maksimal 10080 menit (7 hari)"
  ];

  rejectionRules = [
    (v: string) => !!v || "Alasan wajib diisi",
    (v: string) => (v && v.trim().length >= 5) || "Minimal 5 karakter"
  ];

  get pendingList() {
    return revisionAccessModule.pendingList;
  }

  get historyList() {
    return revisionAccessModule.historyList;
  }

  get loading() {
    return revisionAccessModule.loading;
  }

  get isGrantedMinutesValid() {
    if (this.selected && this.selected.document_type) return true;
    return this.grantedMinutes >= 60 && this.grantedMinutes <= 10080;
  }

  get isRejectionValid() {
    return this.rejectionReason && this.rejectionReason.trim().length >= 5;
  }

  mounted() {
    this.reload();
  }

  @Watch("tab")
  onTabChange(value: number) {
    if (value === 1 && !this.historyList.length) this.loadHistory();
  }

  reload() {
    revisionAccessModule.fetchPending();
    if (this.tab === 1) this.loadHistory();
  }

  loadHistory() {
    revisionAccessModule.fetchHistory(this.historyStatus);
  }

  isOwn(item: RevisionAccessRequest): boolean {
    return Number(item.requester_id) === Number(userModule.user.id);
  }

  openApprove(item: RevisionAccessRequest) {
    if (this.isOwn(item)) return;
    this.selected = item;
    this.grantedMinutes = 1440;
    this.approveNote = "";
    this.approveDialog = true;
  }

  openReject(item: RevisionAccessRequest) {
    if (this.isOwn(item)) return;
    this.selected = item;
    this.rejectionReason = "";
    this.rejectDialog = true;
  }

  async doApprove() {
    if (!this.selected || !this.isGrantedMinutesValid) return;
    this.processing = true;
    try {
      await revisionAccessModule.approve({
        id: this.selected.id,
        granted_minutes: this.selected.document_type
          ? undefined
          : this.grantedMinutes,
        note: this.approveNote || undefined
      });
      appModule.NoticeDelay("Pengajuan disetujui.");
      this.approveDialog = false;
    } catch (e) {
      // Error sudah ditampilkan service
    } finally {
      this.processing = false;
    }
  }

  async doReject() {
    if (!this.selected || !this.isRejectionValid) return;
    this.processing = true;
    try {
      await revisionAccessModule.reject({
        id: this.selected.id,
        rejection_reason: this.rejectionReason.trim()
      });
      appModule.NoticeDelay("Pengajuan ditolak.");
      this.rejectDialog = false;
    } catch (e) {
      //
    } finally {
      this.processing = false;
    }
  }

  formatDate(value?: string | null): string {
    if (!value) return "-";
    const m = moment(value);
    return m.isValid() ? m.format("DD-MM-YYYY HH:mm") : String(value);
  }

  /** Nama pemohon; jatuh ke email lalu id bila pegawai belum terpetakan. */
  requesterName(item: RevisionAccessRequest): string {
    return (
      item.requester_nama ||
      (item.requester ? item.requester.email : `User #${item.requester_id}`)
    );
  }

  approverName(item: RevisionAccessRequest): string {
    return item.approver_nama || (item.approver ? item.approver.email : "-");
  }

  documentLabel(item: RevisionAccessRequest): string {
    if (!item.document_type) return "Seluruh episode (rekam medis terkunci)";
    return item.document_label || item.document_type_label || item.document_type;
  }

  /** No. RM 6 digit dari server; payload lama tetap tampil apa adanya. */
  rmDisplay(item: RevisionAccessRequest): string {
    return item.pasien_rm_display || item.pasien_rm;
  }

  statusColor(status: string): string {
    switch (status) {
      case "approved":
        return "success";
      case "rejected":
        return "error";
      case "expired":
        return "grey";
      case "revoked":
        return "warning";
      case "pending":
        return "info";
      default:
        return "grey";
    }
  }
}
